const GRID_PREFIX = 'common-grid';

/**
 * Build storage key
 */
const buildKey = (storageKey, key) => {
  return `${GRID_PREFIX}:${storageKey}:${key}`;
};

export const saveGridState = (storageKey, key, value) => {
  try {
    localStorage.setItem(buildKey(storageKey, key), JSON.stringify(value));
  } catch (error) {
    console.error('Failed to save grid state', error);
  }
};

export const loadGridState = (storageKey, key, defaultValue = null) => {
  try {
    const value = localStorage.getItem(buildKey(storageKey, key));

    if (value === null || value === undefined) {
      return defaultValue;
    }

    return JSON.parse(value);
  } catch (error) {
    console.error('Failed to load grid state', error);

    return defaultValue;
  }
};

export const removeGridState = (storageKey, key) => {
  try {
    localStorage.removeItem(buildKey(storageKey, key));
  } catch (error) {
    console.error('Failed to remove grid state', error);
  }
};

export const clearGridState = (storageKey) => {
  try {
    const prefix = `${GRID_PREFIX}:${storageKey}:`;

    Object.keys(localStorage).forEach((localStorageKey) => {
      if (localStorageKey.startsWith(prefix)) {
        localStorage.removeItem(localStorageKey);
      }
    });
  } catch (error) {
    console.error('Failed to clear grid state', error);
  }
};
